module.exports = __webpack_public_path__ + "static/media/noun_archive_1133223.292a9f28.svg";